import React, { Component } from "react";
import { Row, Col, Button, Modal, Typography, Form, Spin, Upload, List, message, Table, Switch } from 'antd';
import { UploadOutlined, } from '@ant-design/icons';

import { IconTemplate } from '../../Widgets/Iconos';


const { Title } = Typography;
const axios = require('axios').default;


/**
 *
 *
 * @class ModalMultiplePoductos
 * @extends {Component}
 */
class ModalMultiplePoductos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            accionModal: '',
            loading: false,
            datosConsultados: false,
            return: false,
            tipo: 1,
            actualizarPrecios: false,
        }
    }

    ModalMultiplePoductos = React.createRef();

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');

        if (this.props.proveedor_id !== undefined) {
            this.getProveedor()
        }
    }


    
    /**
     * @memberof ModalMultiplePoductos
     * @method onFinish
     * @description Sube el docuemnto para poder agregar varios productos
     */
        normFile = (e) => {
            const { file, fileList } = e;
            this.setState({loading: true})

            for (let x = 0; x < fileList.length; x++) {
                if (fileList[x].response) {
                    fileList[x].name = fileList[x].response.filename

                }

                if (fileList[x].status !== "done" && fileList[x].response && !this.state.loading) {
                    this.setState({ update: !this.state.update, loading: true })
                    break;
                }
            }


            if(file.status === "error"){
                this.props.onClose()
                message.error(file?.response?.message ?? "Error al subir el archivo")
            }

            /**
             * Cuando se sube un archivo, se debe actualizar la lista de imagenes, cuando se selecciona eliminar, se debe actualizar la lista una vez que se elimina
             */
            if (file.status === "done") {
                this.setState({
                    image: {
                        url: axios.defaults.baseURL + '/upload/' + e.file.response.filename,
                        name: e.file.response.filename
                    },
                });

                this.props.onClose()

                // Verificar si hay errores y descargar CSV si es necesario
                if (e.file.response.hasErrors && e.file.response.csvData) {
                    // Crear y descargar el archivo CSV de errores
                    const blob = new Blob([e.file.response.csvData], { type: 'text/csv' });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = e.file.response.csvFileName || 'errores_productos.csv';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);

                    // Mostrar modal con información de errores
                    Modal.warning({
                        title: 'Archivo procesado con errores',
                        content: (
                        <div>
                            <p>Productos registrados correctamente: <strong>{e.file.response.exitos}</strong></p>
                            <p>Productos NO registrados: <strong>{e.file.response.errores}</strong></p>
                            <p style={{color: '#fa8c16', marginTop: '10px'}}>
                                Se ha descargado automáticamente un archivo CSV con los detalles de los errores.
                            </p>
                        </div>
                        ),
                        onOk() {},
                    });
                } else {
                    // Todo salió bien, mostrar modal de éxito
                    Modal.success({
                        title: 'Archivo procesado correctamente',
                        content: (
                        <div>
                            <p>Productos registrados correctamente: <strong>{e.file.response.exitos}</strong></p>
                            <p>Productos NO registrados: <strong>{e.file.response.errores}</strong></p>
                        </div>
                        ),
                        onOk() {},
                    });
                }
            }

            return e && e.fileList;

        };


    render() {

        const columns = [
            {
                title: 'Campo en Excel (URREA)',
                dataIndex: 'excel',
                key: 'excel',
            },
            {
                title: 'Campo en el Sistema',
                dataIndex: 'sistema',
                key: 'sistema',
            },
        ];

        const dataSource = [
            { key: '1', excel: 'Código', sistema: 'Número de parte NEXUS' },
            { key: '2', excel: 'Código', sistema: 'Número de parte de fabricante' },
            { key: '3', excel: 'Nombre', sistema: 'Descripción' },
            { key: '4', excel: 'Marca', sistema: 'Marca' },
            { key: '5', excel: 'EAN o UPC', sistema: 'SKU' },
            { key: '6', excel: 'costo', sistema: 'Costo' },
            { key: '7', excel: 'costo', sistema: 'Precio unitario' },
            { key: '8', excel: 'Anexo 20 SAT', sistema: 'Clave Producto' },
        ];
       
        return (
            <Form
                layout="vertical"
                ref={this.ModalMultiplePoductos}
                onFinish={this.onFinish}
            >
                <Spin spinning={this.state.loading} tip="Por favor espere, esto puede tardar unos minutos">
                    <Row style={{ margin: "10px 0px", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img src="/Icons/URREA_logo.jpg" alt="Subir archivo Excel" style={{ maxWidth: 250 }}/>
                        <small>v 1.01</small>
                    </Row>
                    <Row align="center" style={{ margin: "20px 0px", padding: '10px 0px' }}>
                        <List
                            style={{ maxHeight: 350, overflowY: 'auto', width: '100%', border: '1px solid gray', borderRadius: 5}}
                            align="center"
                            size="small"
                            header={<strong>Toma en cuenta las siguientes consideraciones.</strong>}
                            dataSource={[
                            	<div style={{ width: '100%' }}>- Sube el archivo oficial de <strong>Urrea</strong> (.xlsx) con los productos para cargarlos en el sistema.</div>,
                                <div style={{ width: '100%' }}>- Cambia el nombre de la columna de <strong>Precio Sub distribuidor</strong> a solamente <strong>costo</strong></div>,
                                <div style={{ width: '100%' }}>- El costo no debe de estar en ningún formato de moneda</div>,
                                <div style={{ width: '100%', marginTop: '15px' }}>
                                    <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>Mapeo de campos:</div>
                                    <Table 
                                        dataSource={dataSource} 
                                        columns={columns} 
                                        pagination={false}
                                        size="small"
                                        bordered
                                    />
                                </div>
                            ]}
                            renderItem={item => <List.Item>{item}</List.Item>}
                        />

                    </Row>
                    <Row align="center" style={{ margin: "10px 0px" }}>
                        <img src="/Icons/upload.svg" alt="Subir archivo Excel" style={{ maxWidth: 250 }}/>
                    </Row>

                    <Row className="ant-row-center">
                        <Col>
                            <Form.Item
                                label={<>¿Desea actualizar el costo y precio de los productos ya existentes? <br /> (seleccione antes de subir el archivo)</>}
                            >
                                <Switch
                                    checked={this.state.actualizarPrecios}
                                    onChange={checked => this.setState({ actualizarPrecios: checked })}
                                    unCheckedChildren="NO"
                                    checkedChildren="SI"
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} lg={20} className="mt-3 mb-3" >
                            <Form.Item
                                label="Archivo (.xlsx)"
                                name="documentos"
                                getValueFromEvent={this.normFile}
                                valuePropName="fileList"
                                className="content-uploader"
                            >
                                <Upload
                                    accept={'csv'}
                                    headers={{ Authorization: axios.defaults.headers.common['Authorization'] }}
                                    action={axios.defaults.baseURL + "/voucher/add/excel/productos?actualizar=" + (this.state.actualizarPrecios ? '1' : '0')}
                                    max={1}
                                    className="width-100"
                                >
                                    <Button className="width-100">
                                        <UploadOutlined /> Agregar archivos
                                    </Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>
                </Spin>
            </Form>
        )
    }
}



export default function Vista(props) {
    const { visible = false, onClose = () => { } } = props

    return <Modal
        visible={visible}
        onCancel={onClose}
        title={null}
        footer={null}
        closable={true}
        destroyOnClose={true}
        zIndex={1000}
    >
        <div className="center">
            <Title level={3}>  Guardar Productos </Title>
        </div>
        <ModalMultiplePoductos {...props} />
    </Modal>

}